import React from 'react'
import { withRouter } from 'react-router-dom'
import { DEV_URL } from '../../config/base';

class About extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    openCEO() {
        window.open(`${DEV_URL}policy/new_ceo.html`, '_blank');
    }
    about() {
        window.open(`${DEV_URL}policy/about_us.html`, '_blank');
    }
    ourTeam() {
        window.open(`${DEV_URL}policy/our_team.html`, '_blank');
    }
    render() {
        return (
            <div className="col ps-md-5">
                <div className="row mb-5 align-items-center">
                    <div className="col-12 col">
                        <h1 className="font18 fw-bold">About</h1>
                    </div>
                </div>
                <div className="accordion accordion-flush" id="faq">
                    <div className="accordion-item">
                        <h2 className="accordion-header text-link" id="shop-heading">
                            <button
                                id="terms-of-use"
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#shop-acc"
                                aria-expanded="false"
                                aria-controls="shop-acc"
                                onClick={() => this.openCEO()}>
                                NEW CEO/PARTNER
                            </button>
                        </h2>
                    </div>


                    <div className="accordion-item">
                        <h2 className="accordion-header text-link" id="shop-heading">
                            <button
                                id="privacy-policy"
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#shop-acc"
                                aria-expanded="false"
                                aria-controls="shop-acc"
                                onClick={() => this.about()}>
                                ABOUT JEDEDIAH'S
                            </button>
                        </h2>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header text-link" id="shop-heading">
                            <button
                                id="Disclaimer"
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#shop-acc"
                                aria-expanded="false"
                                aria-controls="shop-acc"
                                onClick={() => this.ourTeam()}>
                                OUR TEAM
                            </button>
                        </h2>
                    </div>
                </div>


            </div>
        )
    }
}

export default withRouter(About)